import { GuarantiesService } from './../../services/guaranties.service';
import { Warranty } from './../../models/warranty.model';
import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { Service } from '../../models/service.model';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { SelectOption } from '../../models/select-option.model';
import { DataTableColumn } from '../../components/generics/data-table/data-table.component';
import { Quote, QuoteType } from '../../models/quote.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Office } from '../../models/office.model';
import { ErrorResponse } from '../../models/error.model';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
    selector: 'app-requotation-dialog',
    templateUrl: './requotation-dialog.component.html',
    styleUrls: ['./requotation-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class RequotationDialogComponent implements OnInit {

    quoteFG = new UntypedFormGroup({
        tipo: new UntypedFormControl('VIVIENDA', [Validators.required]),
        alquiler: new UntypedFormControl('', [Validators.required]),
        expensas: new UntypedFormControl('', [Validators.required]),
        duracion: new UntypedFormControl(36, [Validators.required]),
        actualizacion: new UntypedFormControl(null, []),
        periodoActualizacion: new UntypedFormControl(null, []),
    });

    updatePeriods: SelectOption[] = [
        { codigo: 3, descripcion: 'Trimestral' },
        { codigo: 6, descripcion: 'Semestral' },
        { codigo: 12, descripcion: 'Anual' },
    ];

    quoteTypes: SelectOption[] = [
        { codigo: 'COMERCIAL', descripcion: 'Comercio' },
        { codigo: 'VIVIENDA', descripcion: 'Vivienda' },
    ];

    terms: SelectOption[] = [
        { codigo: 36, descripcion: '36 meses' }
    ];

    serviceSelectorTableColumns: DataTableColumn[] = [
        { name: 'Servicio', prop: 'nombre' },
    ];

    services: Service[] = [];
    selectedServices: Service[] = [];
    requiredServices: Service[] = [];

    constructor(
        private guarantiesService: GuarantiesService,
        private utilsService: UtilsService,
        private dialogRef: MatDialogRef<RequotationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public warranty: Warranty,
    ) { }

    ngOnInit(): void {
        this.quoteFG.controls.tipo.valueChanges.subscribe((newValue: QuoteType) => {
            this.updateValidators(newValue);
            this.quoteFG.controls.actualizacion.setValue('');
            this.quoteFG.controls.periodoActualizacion.setValue('');
            if (newValue === 'VIVIENDA') {
                this.terms = [
                    { codigo: 36, descripcion: '36 meses' }
                ];
            } else {
                this.terms = [
                    { codigo: 12, descripcion: '12 meses' },
                    { codigo: 24, descripcion: '24 meses' },
                    { codigo: 36, descripcion: '36 meses' },
                    { codigo: 48, descripcion: '48 meses' }
                ];
            }
        });
        this.updateOfficeServices(this.warranty.agente.oficina);
        this.fillFormWithQuotation(this.warranty.cotizacion);
    }

    cerrarDialogo(warranty?: Warranty) {
      this.dialogRef.close(warranty);
    }

    fillFormWithQuotation(quotation: Quote) {
        this.quoteFG.patchValue({
            tipo: quotation.tipo,
            alquiler: quotation.alquiler,
            expensas: quotation.expensas,
            duracion: quotation.duracion,
            actualizacion: quotation.actualizacion,
            periodoActualizacion: quotation.periodoActualizacion,
        });
        this.selectedServices = this.services.filter(service => !!quotation.servicios.find(s => s.id === service.id));
        this.updateValidators(quotation.tipo);
        this.onServiceSelect();
    }

    updateOfficeServices(office?: Office) {
        this.services = [];
        office?.servicios?.forEach(serviceConfig => {
            if (serviceConfig.servicio.tipoProducto === 'GARANTIA' && !this.services.find(service => service.id === serviceConfig.servicio.id)) {
                this.services.push(serviceConfig.servicio);
            }
        });
        const alquilerService = this.services.find(service => service.codigo === 'ALQUILER');
        const expensasService = this.services.find(service => service.codigo === 'EXPENSAS');
        if (alquilerService)
            this.requiredServices.push(alquilerService);
        if (expensasService)
            this.requiredServices.push(expensasService);
        this.selectedServices = [];
        this.onServiceSelect();
    }

    updateValidators(quoteType: QuoteType) {
        if (quoteType === 'COMERCIAL') {
            this.quoteFG.controls.actualizacion.setValidators([Validators.required]);
            this.quoteFG.controls.periodoActualizacion.setValidators([Validators.required]);
        } else {
            this.quoteFG.controls.actualizacion.setValidators([]);
            this.quoteFG.controls.periodoActualizacion.setValidators([]);
        }
    }

    onServiceSelect() {
        setTimeout(() => {
            this.requiredServices.forEach(requiredService => {
                if (!this.selectedServices.find(service => service.id === requiredService.id)) {
                    this.selectedServices.push(requiredService);
                }
            });
        });
    }

    quote() {
        if (!this.quoteFG.valid) return;
        this.guarantiesService.requotation(this.warranty.id, {
            tipo: this.quoteFG.value.tipo,
            alquiler: this.quoteFG.value.alquiler,
            expensas: this.quoteFG.value.expensas,
            duracion: this.quoteFG.value.duracion,
            actualizacion: this.quoteFG.value.actualizacion,
            periodoActualizacion: this.quoteFG.value.periodoActualizacion,
            servicios: this.selectedServices,
        }).subscribe(warranty => {
            this.cerrarDialogo(warranty);
        }, (error: ErrorResponse) => this.utilsService.alert('Error al realizar cotización', error.error?.descripcion));
    }

    rowId = (service: Service) => service.id;

}
